export default __webpack_public_path__ + "static/media/edit-24px.ca3fe17e.svg";